<div class="body">
    <div class="fotoPresentacion">
        <div class="app-radio-inicio">
            <app-radio-new></app-radio-new>
        </div>
    </div>
    <div class="section1">
        <div class="youtube-banner">
            <img width="100%" height="100%" src="/assets/fondos/BannerYouTube.png" alt="">
            <div class="youtube">
                <mat-icon class="play-arrow"> play_arrow </mat-icon>
            </div>
        </div>
        <div class="contentradios">
            <div class="titulos">
                <h1 class="latestVideo">RADIO EN LINEA</h1>
            </div>
            <div class="radio-online">
                <app-radio-online></app-radio-online>
            </div>
        </div>
    </div>
    <mat-divider class="matDivider"></mat-divider>
    <div class="trianguloPadre">
        <div class="triangle-down"></div>
    </div>
    <div class="live-container" *ngIf='actualPlaynig'>
        <div class="row m-0">
            <div class="col-lg-6">
                <div class="img-portada">
                    <img *ngIf='!radioProgram' [src]="actualPlaynig.image" [alt]="actualPlaynig.name">
                    <img *ngIf='radioProgram' [src]="radioProgram.image" [alt]="actualPlaynig.name">
                    <div class="media-actions">
                        <p style="text-align: center;">{{actualPlaynig.name}}</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 radio-text">
                <div class="hra-portada">
                    <p>EN VIVO / {{dateactuall | date:'HH:mm:ss a'}}</p>
                </div>
                <div class="descripcion-portada" *ngIf='radioProgram'>
                    <p>{{radioProgram.name}}</p>
                    <h4>{{radioProgram.description|truncate:"400"}}</h4>
                </div>
                <div class="descripcion-portada" *ngIf='!radioProgram'>
                    <p>Sin Programa</p>
                    <h4>Estamos con contenido fuera de programa</h4>
                </div>
            </div>
        </div>
    </div>

    <!-- ESPACIO PUBLICITARIO -->
    <div>
        <app-publicidad></app-publicidad>
    </div>
    <!-- ESPACIO PUBLICITARIO END -->
    <footer>
        <app-footer-new></app-footer-new>
    </footer>
</div>
